<!--
* 页面名 : 首页
* 开发者 : xx
-->
<template>
  <v-container>
    <v-row class="libraries" v-if="Object.keys(navInfos).length > 0">
      <v-card class="item" v-for="(item, index) in navInfos" :key="index" :ripple="false" @click="on_chang_page(item.driveId)">
        <v-img class="white--text align-end" height="155px" :src="item.thumbnail" />
        <v-card-title>{{ item.name }}</v-card-title>
      </v-card>
    </v-row>
  </v-container>
</template>

<script>
import { mapState, mapMutations } from "vuex";

export default {
  name: "home",
  computed: {
    ...mapState("global", ["navInfos"]),
  },
  methods: {
    ...mapMutations("global", ["updateDriveIdsID"]),

    on_chang_page(driveId) {
      this.updateDriveIdsID([driveId]);
      this.$router.push(`/${driveId}`);
    },
  },
};
</script>

<style lang="scss">
.libraries {
  .v-sheet.v-card {
    width: calc(16.6667% - 24px);
    border-radius: 8px;
    margin: 12px;
    box-shadow: rgba(136, 165, 191, 0.48) 6px 2px 16px 0px, rgba(255, 255, 255, 0.8) -6px -2px 16px 0px !important;
  }
  .v-card__title {
    font-size: 16px;
    font-weight: 600;
    line-height: 1rem;
  }
}

// 去掉点击时的水波纹
a {
  -webkit-tap-highlight-color: rgba(0, 0, 0, 0);
}

@media (max-width: 1610px) {
  .libraries {
    padding: 0 12px;
    .v-sheet.v-card {
      width: calc((100% / 4) - 24px);
    }
  }
}
@media (max-width: 1200px) {
  .libraries .v-sheet.v-card {
    width: calc((100% / 3) - 24px);
  }
}
</style>